import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PromptService } from './data-access/services/prompt.service';
import mockData from './data-access/mocks/prompt-evaluation.json';
import { AgentTypesService } from '../agent-types/data-access/services/agent-types.service';
import { ModalConfirmComponent } from '../../shared/ui/components/modal-confirm/modal-confirm.component';
import { ModalMessageComponent } from '../../shared/ui/components/modal-message/modal-message.component';
import { interval, Subscription } from 'rxjs';
import { switchMap, takeWhile } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-improve-prompt-manual',
  imports: [CommonModule, FormsModule, ModalConfirmComponent, ModalMessageComponent],
  templateUrl: './improve-prompt-manual.component.html',
  styles: ``
})
export class ImprovePromptManualComponent implements OnInit, OnDestroy {
  data: any;

  agentTypes: any[] = [];
  selectedAgentTypeId: number | null = null;
  content: string = '';
  minScore: string = '';
  promptId: number | null = null;

  transcriptions: any[] = [];
  filterText: string = '';
  filterType: string = 'all'; // tipo de transcripción
  selectedTranscription: any = null;
  analyzedTranscription: any = null; // Llamada que se está analizando/analizó
  currentPage: number = 1;
  totalPages: number = 1;
  isLoadingTranscriptions: boolean = false;

  feedbackProduction: any = '';
  feedbackBeta: any = '';
  isSavingPrompt: boolean = false;
  isTestingPrompt: boolean = false;

  productionScore: string | null = null;
  betaScore: string | null = null;

  showConfirmModal = false;
  showMessageModal = false;
  messageModalTitle: string = '';
  messageModalMessage: string = '';
  messageModalType: 'success' | 'error' | 'info' | 'warning' = 'info';

  loadedPage: boolean = false;

  // Control de overlay y polling
  showProcessingOverlay: boolean = false;
  pollingSubscription: Subscription | null = null;
  processId: number | null = null;
  processProdId: number | null = null;

  constructor(private promptService: PromptService, private typesService: AgentTypesService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    // this.data = mockData;
    // // Si hay feedbacks en mockData, extraer scoring
    // if (mockData?.feedback) {
    //   this.feedbackProduction = mockData.feedback.production || '';
    //   this.feedbackBeta = mockData.feedback.beta || '';
    //   this.productionScore = this.extractScore(this.feedbackProduction);
    //   this.betaScore = this.extractScore(this.feedbackBeta);
    // }
    this.loadPromptOptions();
  }

  loadPromptOptions(): void {
    this.typesService.getAgentTypes().subscribe({
      next: (options) => {
        this.agentTypes = options;

        if (this.agentTypes.length > 0) {
          this.selectedAgentTypeId = this.agentTypes[0].id;
          this.loadPromptSandbox(this.agentTypes[0].id);
          this.loadTranscriptions(this.agentTypes[0].id);
        }
      },
      error: (error) => {
        console.error('Error cargando opciones de prompt:', error);
      }
    });
  }

  loadPromptSandbox(typeId: number): void {
    this.promptService.getPromptSandbox(typeId).subscribe({
      next: (detail) => {
        this.promptId = detail.id;
        this.minScore = detail.min_score;
        this.content = detail.content || '';
        this.loadedPage = true;
      },
      error: (error) => {
        this.showConfirmModal = true;
        this.loadedPage = true;
        console.error('Error cargando detalles del prompt sandbox:', error);
      }
    });
  }

  onAgentTypeChange(): void {
    if (this.selectedAgentTypeId) {
      this.promptId = null;
      this.minScore = '';
      this.content = '';
      this.loadPromptSandbox(this.selectedAgentTypeId);
      this.transcriptions = [];
      this.selectedTranscription = null;
      this.feedbackProduction = '';
      this.feedbackBeta = '';
      this.loadTranscriptions(this.selectedAgentTypeId);
    }
  }

  loadTranscriptions(typeId: number, page: number = 1): void {
    this.isLoadingTranscriptions = true;
    this.promptService.getVoiceTranscriptions(typeId, page).subscribe({
      next: (response) => {
        this.transcriptions.push(...response.data);
        this.currentPage = response.pagination.current_page;
        this.totalPages = response.pagination.last_page;
        this.isLoadingTranscriptions = false;

        if (!this.selectedTranscription && response.data.length > 0) {
          this.selectedTranscription = response.data[0];
        }
      },
      error: (error) => {
        console.error('Error cargando transcripciones:', error);
        this.isLoadingTranscriptions = false;
      }
    });
  }

  get filteredTranscriptions(): any[] {
    let filtered = this.transcriptions;
    // Solo filtrar si el filtro es mobile o phone
    if (this.filterType === 'mobile' || this.filterType === 'phone') {
      filtered = filtered.filter(t => t.type === this.filterType);
    }
    if (this.filterText.trim()) {
      const txt = this.filterText.trim().toLowerCase();
      filtered = filtered.filter(t =>
        (t.title && t.title.toLowerCase().includes(txt)) ||
        (t.start_time && ('' + t.start_time).toLowerCase().includes(txt))
      );
    }
    return filtered;
  }

  get transcriptionTypes(): string[] {
    // Solo tipos mobile o phone
    return this.transcriptions
      .map(t => t.type)
      .filter((v, i, a) => (v === 'mobile' || v === 'phone') && a.indexOf(v) === i);
  }
  loadMoreTranscriptions(): void {
    if (this.currentPage < this.totalPages && !this.isLoadingTranscriptions && this.selectedAgentTypeId) {
      this.loadTranscriptions(this.selectedAgentTypeId, this.currentPage + 1);
    }
  }

  savePrompt(): void {
    if (!this.selectedTranscription) return;
    this.isSavingPrompt = true;

    this.promptService.savePromptSandbox(this.promptId!, this.minScore, this.content).subscribe({
      next: (response) => {
        this.isSavingPrompt = false;
        this.showMessage('Éxito', 'Prompt guardado correctamente', 'success');
      },
      error: (error) => {
        console.error('Error guardando prompt:', error);
        this.isSavingPrompt = false;
      }
    });
  }

  testPrompt() {
    if (!this.selectedTranscription) return;

    this.isTestingPrompt = true;
    this.analyzedTranscription = this.selectedTranscription; // Guardar la llamada que se está analizando
    this.feedbackProduction = '';
    this.feedbackBeta = '';
    this.productionScore = null;
    this.betaScore = null;

    this.promptService.testPrompt(this.promptId!, this.selectedTranscription.id, this.content, this.minScore).subscribe({
      next: (response) => {
        // Verificar si la respuesta viene con error o es exitosa
        if (!response || response.error) {
          // Si hay error, no mostrar overlay ni hacer polling
          this.isTestingPrompt = false;
          this.showMessage('Error', 'Error al procesar la llamada', 'error');
          return;
        }

        // Guardar los IDs del proceso
        this.processId = response.beta?.process || null;
        this.processProdId = response.production?.process || null;

        // Mostrar overlay de procesamiento
        this.showProcessingOverlay = true;

        // Esperar 1 minuto y medio (90000ms) antes de empezar el polling
        setTimeout(() => {
          this.startPolling();
        }, 90000);
      },
      error: (error) => {
        console.error('Error guardando prompt:', error);
        this.isTestingPrompt = false;
        this.showMessage('Error', 'Error al iniciar el test del prompt', 'error');
      }
    });
  }

  startPolling(): void {
    if (!this.processId) {
      this.stopProcessing();
      return;
    }

    let elapsedTime = 0;
    const maxTime = 8 * 60 * 1000; // 8 minutos en milisegundos
    const pollingInterval = 5000; // 5 segundos

    // Hacer polling cada 5 segundos
    this.pollingSubscription = interval(pollingInterval).pipe(
      switchMap(() => {
        elapsedTime += pollingInterval;

        // Si ha pasado más de 8 minutos, detener
        if (elapsedTime >= maxTime) {
          this.showMessage('Tiempo agotado', 'El proceso ha excedido el tiempo máximo de espera', 'warning');
          this.stopProcessing();
          return [];
        }

        return this.promptService.getStatusTest(this.processId!, this.processProdId || undefined);
      }),
      takeWhile((response) => {
        // Continuar mientras el estado sea 'pending' y no hayamos superado el tiempo máximo
        return response?.status === 'pending' && elapsedTime < maxTime;
      }, true) // true para incluir la última emisión
    ).subscribe({
      next: (response) => {
        if (response?.status !== 'pending') {
          // El proceso ha terminado
          if (response.status === 'completed') {
            this.feedbackBeta = this.sanitizer.bypassSecurityTrustHtml(response.result || '');
            this.betaScore = response.score || null;
            if (response.production_status && response.production_status === 'completed') {
              this.productionScore = response.production_score || null;
              this.feedbackProduction = this.sanitizer.bypassSecurityTrustHtml(response.production_result || '');
            }
          }
          this.stopProcessing();
        }
      },
      error: (error) => {
        console.error('Error en polling:', error);
        this.stopProcessing();
        this.showMessage('Error', 'Error al obtener el estado del proceso', 'error');
      }
    });
  }

  stopProcessing(): void {
    this.showProcessingOverlay = false;
    this.isTestingPrompt = false;
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
      this.pollingSubscription = null;
    }
    this.processId = null;
    this.processProdId = null;
  }

  /**
   * Extrae el scoring del texto de feedback, buscando patrones como "Puntuación: 65/100" o "Scoring: 72/100".
   */
  extractScore(text: string): string | null {
    if (!text) return null;
    // Busca "Puntuación: xx/100" o "Scoring: xx/100" (acepta espacios y variantes)
    const match = text.match(/(?:Puntuación|Scoring)\s*[:：]?\s*(\d{1,3})\s*\/\s*100/i);
    if (match) {
      return match[1] + '/100';
    }
    // Busca solo número + "/100" si no hay palabra clave
    const match2 = text.match(/(\d{1,3})\s*\/\s*100/);
    if (match2) {
      return match2[1] + '/100';
    }
    return null;
  }

  onModalAction(action: string) {
    if (action === 'confirm') {
      this.promptService.createPromptSandbox(this.selectedAgentTypeId!).subscribe({
        next: (res) => {
          this.promptId = res.id;
          this.showConfirmModal = false;
        }
      });
    } else {
      this.closeModal();
    }
  }

  private closeModal() {
    this.showConfirmModal = false;
  }

  showMessage(title: string, message: string, type: 'success' | 'error' | 'info' | 'warning') {
    this.messageModalTitle = title;
    this.messageModalMessage = message;
    this.messageModalType = type;
    this.showMessageModal = true;
  }

  closeMessageModal() {
    this.showMessageModal = false;
  }

  ngOnDestroy(): void {
    // Limpiar suscripción al destruir el componente
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }
}